import {Navigate, useLocation} from 'react-router';

/**
 * The old station list's address: My weather lists the user's stations for
 * everyone now (FE #381). The query and the hash go along.
 */
const ToMyWeather = () => {
  const {search, hash} = useLocation();
  return <Navigate to={{pathname: '/app/', search, hash}} replace />;
};

export default ToMyWeather;
